import { render } from "./diskDetection.vue?vue&type=template&id=8d5a2bea&scoped=true"
import script from "./diskDetection.vue?vue&type=script&lang=js"
export * from "./diskDetection.vue?vue&type=script&lang=js"

import "./diskDetection.vue?vue&type=style&index=0&id=8d5a2bea&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d5a2bea"]])

export default __exports__